<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播曝光</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>

      <el-col :span="3">
        <el-input v-model="hostRid" placeholder="主播id 选填"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="isLive"
          placeholder=""
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="是live" :value="1"></el-option>
          <el-option label="不是live " :value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="exposurePosition"
          placeholder=""
        >
          <el-option label="discover页面" value="discover"></el-option>
          <el-option label="popular页面" value="popular"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        height="70vh"
        stripe
        border
      >
        <el-table-column prop="datePeriod" fixed label="日期周期" width="174">
        </el-table-column>
        <el-table-column prop="hostId" fixed label="主播ID" width="90">
        </el-table-column>
        <el-table-column prop="lang" fixed label="主播语言" width="107">
        </el-table-column>
        <el-table-column prop="onlineTime" label="在线时长-min" width="110">
        </el-table-column>
        <el-table-column prop="liveTime" label="live时长-s" width="110">
        </el-table-column>
        <el-table-column
          prop="totalExposureCount"
          label="曝光总次数"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="totalExposureNumberOfPeople"
          label="曝光总人数"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="totalValidExposureCount"
          label="有效曝光总次数"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="totalValidExposureNumberOfPeople"
          label="有效曝光总人数"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="buttonCallCount"
          label="直接按钮拨打次数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="buttonCallNumberOfPeople"
          label="直接按钮拨打人数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="buttonCallRate"
          label="直接按钮拨打率"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="buttonValidCount"
          label="按钮有效拨打次数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="buttonValidNumberOfPeople"
          label="按钮有效拨打人数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="buttonValidCallRate"
          label="按钮有效拨打率"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="clickCount"
          label="点击次数（非拨打按钮）	"
          width="160"
        >
        </el-table-column>
        <el-table-column prop="clickRate" label="点击率" width="100">
        </el-table-column>
        <el-table-column
          prop="homepageExposureCount"
          label="主页曝光次数"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="homepageCallCount"
          label="主页拨打次数"
          width="100"
        >
        </el-table-column>
        <el-table-column prop="homepageCallRate" label="主页拨打率" width="100">
        </el-table-column>
        <el-table-column
          prop="validClickCount"
          label="有效点击次数（非拨打按钮）"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="validClickRate" label="有效点击率" width="110">
        </el-table-column>
        <el-table-column
          prop="homepageValidExposureCount"
          label="主页有效曝光次数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="homepageValidCallCount"
          label="主播主页有效拨打次数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="homepageValidCallRate"
          label="主播主页有效拨打率"
          width="150"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getLanguage } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      hostRid: '',
      language: 'all',
      languageList: [],
      isLive: -1,
      exposurePosition: 'discover'
    }
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
  },
  methods: {
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.host_exposure,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          isLive: this.isLive,
          hostRid: this.hostRid,
          exposurePosition: this.exposurePosition
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.host_exposure_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          isLive: this.isLive,
          hostRid: this.hostRid,
          exposurePosition: this.exposurePosition
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播曝光' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
